import { select } from '@angular-redux/store';
import { Injectable, Injector } from '@angular/core';
import { rx } from '@app/shared/rx/rx-wrapper';
import { COMPANY_PREFERENCES_DEFAULTS } from '@config/company-preferences-defaults';
import { Primitive } from '@geniuspos/ui-shared';
import { TranslateLoader } from '@ngx-translate/core';
import { isEmpty, isEqual } from 'lodash';
import { Observable } from 'rxjs';
import { STATE_KEYS } from '../state-service/state-selectors';
import { TranslationService } from '../translate/translation.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderService implements TranslateLoader {
  @select(STATE_KEYS.COMPANY_PREFERENCES)
  private companyPreferences$: Observable<string | undefined>;

  public constructor(
    public injector: Injector,
    public translationService: TranslationService,
  ) {}

  public getTranslation(
    lang: string,
  ): Observable<Record<string, Primitive | Object>> {
    // make sure we have a company preferences loaded
    return this.companyPreferences$.pipe(
      rx.filter(
        (preferences) =>
          !isEmpty(preferences) &&
          !isEqual(preferences, COMPANY_PREFERENCES_DEFAULTS),
      ),
      rx.first(),
      rx.switchMap(() => {
        return this.translationService.getTranslationDictionary({
          locale: lang,
        });
      }),
    );
  }
}
